
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWidgetAddGoogle as ObiWidgetAddGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-widget-add-google.js';
 
 
 

 
 export const ObiWidgetAddGoogle = createComponent({
   react: React,
   tagName: 'obi-widget-add-google',
   elementClass: ObiWidgetAddGoogleElement,
   events: {
     
   }
  });
 
 